module.exports = __webpack_public_path__ + "img/wifi-title.97433610.png";